/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonSharingVisibilityFromJSON, InternalCommonSharingVisibilityToJSON, } from './InternalCommonSharingVisibility';
/**
 * @export
 */
export const InternalCommonCustomAttributeBooleanTypeTypeEnum = {
    Boolean: 'boolean'
};
/**
 * Check if a given object implements the InternalCommonCustomAttributeBooleanType interface.
 */
export function instanceOfInternalCommonCustomAttributeBooleanType(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('visibility' in value) || value['visibility'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('value' in value) || value['value'] === undefined)
        return false;
    return true;
}
export function InternalCommonCustomAttributeBooleanTypeFromJSON(json) {
    return InternalCommonCustomAttributeBooleanTypeFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeBooleanTypeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'visibility': InternalCommonSharingVisibilityFromJSON(json['visibility']),
        'type': json['type'],
        'value': json['value'],
    };
}
export function InternalCommonCustomAttributeBooleanTypeToJSON(json) {
    return InternalCommonCustomAttributeBooleanTypeToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeBooleanTypeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'visibility': InternalCommonSharingVisibilityToJSON(value['visibility']),
        'type': value['type'],
        'value': value['value'],
    };
}
